/**
 * 待办审批 processDefinitionKey 前缀 → 详情页路由 name
 * 以 ApprovalTab 为准，新增流程在此维护即可
 */
export const APPROVAL_ROUTE_MAP = {
  MDM_MOULDS_AUDIT: 'MoldMasterDataDetail',
  MDM_MOULDS_CHANGES_AUDIT: 'MoldMouldsChangeDetail',
  MDM_MOULDS_SCRAPS_AUDIT: 'MoldMouldsScrapDetail',
  MODM_MOULDS_INSPECTIONS_AUDIT: 'MoldMouldsInspectionDetail',
  CCT_CONTRACT_TEMP: 'CctContractTempDetail',
  CCT_CONTRACT_ITEM: 'CctContractItemDetail',
  QUALIFICATION_REVIEW: 'QualificationReviewDetail',
  LOCALE_INSPECT: 'LocaleInspectDetail',
  SAMPLE_TRIAL: 'SampleTrialDetail',
  SUPPLIER_REGISTER: 'SupplierRegisterApproveDetail',
  INSIDE_REGISTER: 'InsideRegisterApproveDetail',
  HK_REGISTER: 'InsideRegisterApproveDetail',
  SlcQualified: 'QualifiedSupplierApproveDetail',
  SLC_CHANGE: 'SupplierChangeDetail',
  PUR_FEE: 'AdditionalFeeApproveDetail',
  SLC_FREEZE_UNFREEZE: 'SupplierFreezeUnfreezeApproveDetail',
  SUPPLIER_STATUS_CHANGE: 'SupplierStatusChangeApproveDetail',
  PRICING_SUMMARY: 'FixedPriceApproveDetail',
  PRICING_SUMMARY_MO: 'FixedPriceApproveDetail',
  PUR_PRICE_APPLY: 'PurPriceApplyApproveDetail',
  SFD_BIDDING: 'CompeteAwardApproveDetail',
  BIDDING_PUBLISH: 'BiddingPublishDetail',
  BIDDING_AWARD: 'BiddingPicketageDetail',
  JXPF: 'SrmSpeSchemeScoreEdit',
  JXHZ: 'SrmSpeSchemeScoreTotalEdit',
}

/** 从 processDefinitionKey（如 QUALIFICATION_REVIEW.7）解析详情路由 name */
export function resolveApprovalRouteName (processDefinitionKey) {
  if (processDefinitionKey == null || processDefinitionKey === '') return undefined
  const type = String(processDefinitionKey).split('.')[0]
  return APPROVAL_ROUTE_MAP[type]
}

/** 列表项 / 外链 action 字段名不一致时统一为详情页 query */
export function buildApprovalDetailQuery (item) {
  if (!item) return {}
  const businessKey = item.bpmBusinessKey != null ? item.bpmBusinessKey : item.businessKey
  const title = item.bpmTitle != null ? item.bpmTitle : item.title
  return {
    businessKey,
    title,
    processDefinitionId: item.processDefinitionId,
    processDefinitionKey: item.processDefinitionKey,
    processInstanceId: item.processInstanceId,
    taskId: item.taskId,
  }
}



// WEBPACK FOOTER //
// ./src/page/srm/pendingApproval/utils/approvalRouteMap.js